import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Popover } from 'primeng/popover';
import { InfoRegistroModel } from '@models/info-registro.model';

@Component({
  selector: 'app-info-registro',
  standalone: false,
  templateUrl: './info-registro.component.html',
  styleUrl: './info-registro.component.scss'
})
export class InfoRegistroComponent implements OnChanges, OnInit, OnDestroy {

  @Input({ required: true }) info: InfoRegistroModel;
  @Input() disabled: boolean = false;
  @Input() disableSalvar: boolean = false;
  @Output() observacaoSalva = new EventEmitter<InfoRegistroModel>();

  @ViewChild('popover') popover: Popover;

  observacaoEditada: string = '';

  constructor(private elementRef: ElementRef) {}

  private readonly captureClickListener = (event: MouseEvent) => {
    if (!this.popover?.overlayVisible) return;
    const target = event.target as HTMLElement;
    if (this.elementRef.nativeElement.contains(target) || target.closest('.p-popover')) return;
    this.popover.hide();
  };

  ngOnInit(): void {
    document.addEventListener('click', this.captureClickListener, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.captureClickListener, true);
  }

  get temObservacao(): boolean {
    return !!this.info?.observacao;
  }

  ngOnChanges(): void {
    this.observacaoEditada = this.info?.observacao ?? '';
  }

  toggle(event: Event): void {
    this.popover.toggle(event);
  }

  salvar(): void {
    this.info.observacao = this.observacaoEditada;
    this.observacaoSalva.emit(this.info);
    this.popover.hide();
  }
}
